import React from "react";
import moment from "moment";
import { withTranslation } from "react-i18next";
import withNotification from "@hooks/useNotification";
import "date-fns";
import "@responsivity/responsivityMobile/Employer/parcoursCertifications.css";
import ModalIndex from "@Modals/layout/index";
import DefaultDatePicker from "@components/arhDatePicker/DefaultDatePicker";
import { getIdForSplitURL } from "@helpers/_functions";
import { Employer } from "@services/all.services";

class ModalEditEndJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dateValue: null,
      description: props?.description
    };
    this.employerId = getIdForSplitURL(6);
  }

  componentDidMount() {
    const { dateUpdate, description } = this.props;
    this.setState({
      description,
      dateValue: dateUpdate ? new Date(dateUpdate) : null
    });
  }

  componentDidUpdate(prevProps) {
    const { dateUpdate } = this.props;
    if (prevProps.dateUpdate !== dateUpdate) {
      this.setState({
        dateValue: dateUpdate ? new Date(dateUpdate) : null
      });
    }
  }

  formatDate(date) {
    return moment(date).format("LL");
  }

  onClickSave = () => {
    const { dateValue, description } = this.state;
    let dataUser = {
      dateEndEmploi: dateValue,
      descriptionEndEmploi: description
    };
    const employeeId = this.props.employeeId;
    if (employeeId) {
      Employer.changeStatusOrLang(dataUser, employeeId)
        .then((response) => {
          if (response?.data?.message) {
            const message = response?.data?.message;
            if (response.status === 200) {
              this.props.onClickClose();
              this.props.showSuccess(message);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  onChangeDescription = ({ target: { value } }) => {
    this.setState({ description: value });
  };

  render() {
    const { dateValue, description } = this.state;
    return (
      <ModalIndex
        isOpen={this.props.isOpen}
        onClickClose={this.props.onClickClose}
        title={this.props.t("Editer la date de fin")}
        buttonOptions={{
          click: this.onClickSave,
          color: "green",
          title: this.props.t("Enregistrer")
        }}
        buttonCancelOptions={{
          click: this.props.onClickClose,
          color: "outlined",
          title: this.props.t("Annuler")
        }}
      >
        <div className="modalContentCourse modalFin_Emploi !arh-p-0">
          <div className="filterSelect position_relative separation_fin_emplois employerThemeDatePicker calendar_with_btn">
            <DefaultDatePicker
              className="focus_green dateOfBirth"
              setDateValue={(date) => {
                this.setState({ dateValue: date });
              }}
              dateValue={dateValue}
              classPosition="w-100"
              classWidth="w-100"
            />
          </div>
          <textarea
            value={description}
            onChange={this.onChangeDescription}
            placeholder="Description"
            className="regular notes_area focus_green GreenThemeSelect form-control note_upload_image"
            name="description"
            id="description"
          />
        </div>
      </ModalIndex>
    );
  }
}

export default withTranslation("pages.employés.parcours&Certifications")(
  withNotification(ModalEditEndJob)
);
